import React, { useCallback } from 'react'

import type { IControlProps } from 'components/controls/Field/Field.types'
import type { ITimePickerProps } from 'components/uiKit/TimePicker'
import TimePicker from 'components/uiKit/TimePicker'

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldTime: React.FC<IControlProps<ITimePickerProps>> = ({
  onChange,
  name,
  value,
  defaultValue,
  ...rest
}) => {
  const handleChange = useCallback(
    (value: number | null) => onChange({ value, name }),
    [name, onChange],
  )

  return <TimePicker {...rest} name='time' onChange={handleChange} value={value ?? defaultValue} />
}

export default FieldTime
